/**
 * Modules that are permanently hidden from the application UI.
 *
 * These features are kept in the codebase for a future launch, but are never
 * rendered: navigation entries are filtered out and routes are blocked,
 * regardless of what the database module_settings table says.
 *
 * To launch one of these modules later, simply remove its key from this list
 * (and enable it in Admin → Modules).
 */
export const PERMANENTLY_HIDDEN_MODULES: readonly string[] = [
  "forex_trading",
  "nft_marketplace",
  "web3_hub",
  "demo_trading",
];

export function isModulePermanentlyHidden(key?: string | null): boolean {
  return !!key && PERMANENTLY_HIDDEN_MODULES.includes(key);
}
